// extracted by mini-css-extract-plugin
export default {"text":"Article_text__+d4cn","highlighted":"Article_highlighted__4gMT9","secondaryHighlighted":"Article_secondaryHighlighted__Tonfa","newHighlighted":"Article_newHighlighted__quaQi"};